module.exports = __webpack_public_path__ + "img/elsa.f8d2830b.jpeg";